<template>
  <q-chip
    v-if="value && component === 'chip'"
    :key="label"
    square
    dense
    clickable
    @click.stop="cycleTimeZoneMode"
  >
    <q-icon
      v-if="format === 'icon'"
      name="schedule"
    />
    <span v-else>{{ formattedValue }}</span>

    <formatted-date-mode-icon
      v-if="(shouldShowTimezoneControls || timezoneMode.value === TIMEZONE_MODES.RELATIVE) && format !== 'icon'"
      :formatted-date-component="this"
    />
    <q-tooltip>
      {{ $_.startCase(timezoneMode.value) }} Time
    </q-tooltip>
    <formatted-date-tooltip :formatted-date-component="this" />
  </q-chip>
  <q-input
    v-else-if="component === 'input'"
    :key="label"
    readonly
    :label="label"
    :model-value="formattedValue"
    @click.stop="shouldShowTimezoneControls && (showDetailTimeTable = !showDetailTimeTable)"
    @mouseleave="showDetailTimeTable = false"
  >
    <template #append>
      <formatted-date-mode-icon
        v-if="shouldShowTimezoneControls"
        :formatted-date-component="this"
      />
    </template>
      &nbsp;
    <formatted-date-tooltip :formatted-date-component="this" />
  </q-input>
  <div
    v-else-if="component === 'div'"
    style="cursor: pointer;"
    @mouseover="showDetailTimeTable = true"
    @mouseleave="showDetailTimeTable = false"
    @click.stop="cycleTimeZoneMode"
  >
    {{ formattedValue }}
    <formatted-date-mode-icon
      v-if="shouldShowTimezoneControls"
      :formatted-date-component="this"
    />
    <formatted-date-tooltip :formatted-date-component="this" />
  </div>
</template>

<script>
import { formatTime, IsoDateTime, TIMEZONE_MODES, timezoneMode } from 'src/models/Model'
import FormattedDateModeIcon from 'src/modules/admin/components/FormattedDateModeIcon'
import FormattedDateTooltip from 'src/modules/admin/components/FormattedDateTooltip'

export default {
  name: 'FormattedDate',
  components: { FormattedDateTooltip, FormattedDateModeIcon },
  props: {
    value: {
      type: null,
      required: false,
      default: null
    },
    format: {
      type: String,
      required: false,
      default: 'dateTime'
    },
    component: {
      type: String,
      required: false,
      default: 'chip'
    },
    label: {
      type: String,
      required: false,
      default: 'Date'
    },
    allowRelative: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      showDetailTimeTable: false
    }
  },
  computed: {
    siteTimeValue () {
      return this.currentSite.inSiteTime(this.value)
    },
    localTimeValue () {
      return new IsoDateTime(this.value)
    },
    formattedValue () {
      return formatTime(this.value, this.format, null, this.allowRelative)
    },
    modeIconName () {
      switch (timezoneMode.value) {
        case TIMEZONE_MODES.SITE:
          return 'store'
        case TIMEZONE_MODES.LOCAL:
          return 'event'
        case TIMEZONE_MODES.RELATIVE:
          return 'history'
        default:
          throw new Error(`Unknown timezone mode: ${timezoneMode.value}`)
      }
    }
  },
  created () {
    const currentTime = IsoDateTime.parse(new IsoDateTime().format('YYYY-MM-DDTHH:mm:ssZ'))
    const siteAndLocalZoneMatch = this.currentSite.inSiteTime(currentTime) - currentTime === 0
    const shouldShowTimezoneControls = !siteAndLocalZoneMatch

    let modeOptions
    if (siteAndLocalZoneMatch) {
      modeOptions = [TIMEZONE_MODES.SITE, TIMEZONE_MODES.RELATIVE]
    } else {
      modeOptions = [TIMEZONE_MODES.SITE, TIMEZONE_MODES.LOCAL, TIMEZONE_MODES.RELATIVE]
    }

    _.extend(this, { timezoneMode, siteAndLocalZoneMatch, shouldShowTimezoneControls, modeOptions, TIMEZONE_MODES })
  },
  methods: {
    cycleTimeZoneMode () {
      const index = this.modeOptions.indexOf(this.timezoneMode.value)

      // Use modulus operator to wrap around to the start of the array
      this.timezoneMode.value = this.modeOptions[(index + 1) % this.modeOptions.length]
    }
  },
  configuration: ['currentSite']
}

</script>
